import styled from 'styled-components';

import {
  DeviceCard,
  DynamicGrid,
  Skeleton,
} from '@soluto-private/mx-asurion-ui-react';

import { kebabize } from '@service-initiation/shared-utils-helpers';
import { type DeviceDetails } from '@service-initiation/tech-care-data-access-tech-care-services';

const Container = styled.div``;

const DevicesGrid = styled(DynamicGrid)`
  margin-bottom: 36px;
`;

const MAX_DEVICES_TO_SHOW = 5;

export type DeviceTypeCardGridPropsProps = {
  deviceTypes: DeviceDetails[];
  handleDeviceCardClick: (selectedDeviceId: number, deviceName: string) => void;
  loading?: boolean;
};

export const DeviceTypeCardGrid = ({
  deviceTypes,
  handleDeviceCardClick,
  loading,
}: DeviceTypeCardGridPropsProps) => (
  <Container>
    <DevicesGrid autoFit minWidth={8}>
      {loading
        ? [...Array(MAX_DEVICES_TO_SHOW)].map((_, i) => (
            <Skeleton
              data-testid={`device-card-skeleton-${i}`}
              height="150px"
              key={`skeleton-${i}`}
            />
          ))
        : deviceTypes?.slice(0, MAX_DEVICES_TO_SHOW).map((device) => (
            <DeviceCard
              data-testid={`device-card-${kebabize(device?.name)}`}
              imageSrc={device?.imageLink}
              key={device?.id}
              onClick={() => {
                handleDeviceCardClick(device?.id, device?.name);
              }}
              primary={
                device?.name === 'Other device'
                  ? 'Something else'
                  : device?.name
              }
            />
          ))}
    </DevicesGrid>
  </Container>
);
